import { Centre } from '../../types/centre'
import { META_FALLBACK_IMAGE } from './../constants'

export const centreAddress = (
  centre: Pick<Centre, 'suburb' | 'state' | 'postcode' | 'physicalAddress'>
): Record<string, any> => ({
  '@type': 'PostalAddress',
  addressLocality: centre.suburb,
  addressRegion: centre.state,
  postalCode: centre.postcode,
  streetAddress: centre.physicalAddress,
})

const tradingHoursToStructuredData = (
  hours: Centre['tradingHours']
): Record<string, any> =>
  hours.map(tradingHoursOfADay => ({
    '@type': 'OpeningHoursSpecification',
    opens: tradingHoursOfADay.openingTime,
    closes: tradingHoursOfADay.closingTime,
    validFrom: tradingHoursOfADay.date,
    validThrough: tradingHoursOfADay.date,
  }))

export const getCentreStructuredData = ({
  url,
  centre,
  name,
  description,
  tradingHours,
}: {
  url: string
  centre: Pick<
    Centre,
    | 'suburb'
    | 'state'
    | 'postcode'
    | 'physicalAddress'
    | 'facebook'
    | 'instagram'
  >
  name: string
  description: string
  tradingHours?: Centre['tradingHours']
}): Record<string, any> | null => {
  // TODO: In event a url is not available don't return incomplete structured data
  if (!url) {
    return null
  }

  return {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name,
    url,
    description,
    mainEntity: {
      openingHoursSpecification:
        tradingHours && tradingHoursToStructuredData(tradingHours),
      '@type': 'ShoppingCenter',
      name,
      image: META_FALLBACK_IMAGE,
      description,
      url,
      address: centreAddress(centre),
      sameAs: [centre.facebook, centre.instagram].filter(elem => elem),
    },
  }
}
